<template>
  <router-view name="user" v-bind:key="$route.path"></router-view>
</template>
<script>
export default {
  name: "User",
};
</script>
